import { progressPercent } from "../lib/goalMinutes";

interface Props {
  value: number;
  max: number;
}

export default function ProgressBar(props: Props) {
  const pct = () => progressPercent(props.value, props.max);

  return (
    <div class="progress-track" role="progressbar" aria-valuenow={pct()}>
      <div class="progress-fill" style={{ width: `${pct()}%` }} />
    </div>
  );
}
